define(
    'viewmodels/secured/explorer/navigation/deleted/deleted',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "viewmodels/secured/explorer/navigation/menu",
        "services/service.documents",
        "providers/dataprovider",
        "services/BusyTracker",
        "i19n!i19n/strings"
    ],
    function(ctx, ViewModel, menu, documentsService, dataProvider, BusyTracker, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            menu: menu,
            deletedMenuItem: new menu.Item(true, 'deleted'),
            permissions: ko.observable()
        });

        vm.menu.items().push(vm.deletedMenuItem);

        vm.deletedMenuItem.isSelected.subscribe(function (newValue) {
            ctx.onNavFolder(null); //to hide results grid
            
            vm.permissions(null);

            if (!newValue) {                
                return;
            }

            //note: we go get permissions everytime the user opens the dropdown. this could potentionally be done once if deemed appropriate.
            dataProvider.accessControl.deletedDocuments
            .getAllowedActions()
            .done(function (permissions) {
                vm.permissions(permissions);
            });
        });

        vm.showMyDocumentsAction = ko.asyncCommand({
            canExecute: function () {
                return vm.deletedMenuItem.isSelected(); 
            },
            execute: function (complete) {
                ctx.onNavMyDeleted(null);
                
                complete();
            }
        });
        vm.showAllDocumentsAction = ko.asyncCommand({
            canExecute: function () {
                return vm.deletedMenuItem.isSelected() && (vm.permissions() & dataProvider.accessControl.deletedDocuments.actions.showAllDeletedDocuments);
            },
            execute: function (complete) {
                ctx.onNavAllDeleted(null);
                
                complete();
            }
        });

        return vm;

    });
